<template>
    <div class="print-container">
        <print-info />
        <div class='row q-ma-lg myBorder' v-bind:class='{"filter-mark" : isFilter}'>
                <q-select
                    name = "filter_stanok"
                    v-model=filter_stanok
                    float-label="Фильтр: Станок"
                    filter
                    clearable
                    radio
                    inverted
                    color=positive
                    autofocus-filter
                    filter-placeholder = "Фильтр"
                    :options="getStanoks"
                    separator
                    style="width:250px"
                    class='q-ma-sm'
                />
                <q-select
                    name = "filter_material"
                    v-model=filter_material
                    float-label="Фильтр: Материал"
                    filter
                    clearable
                    radio
                    inverted
                    color=tertiary
                    autofocus-filter
                    filter-placeholder = "Фильтр"
                    :options="getMaterials"
                    separator
                    style="width:350px;"
                    class='q-ma-sm'
                />


        </div>

        <div v-for="(order) in allOrders"
            :key=order.id>

           <print-order :order='order'/>

        </div>
        <!-- Добавляем немного пустого поля снизу -->
        <div style="height:20px; width:100%"></div>
        <write-off-line/>
    </div>
    
</template>

<script>
/* eslint-disable */
import printOrder from './printOrder'
import printInfo from './../informers/printInfo'

export default {
    name : 'printTerminal',

    data () {
            return {
                filter_stanok : null,
                filter_material : null,
                allowedDirections : [1, 2],
            }
    },

    components : {
        printOrder,
        writeOffLine : ()=>import('./printTerminalWriteOff.vue'),
        printInfo,
    },

    beforeDestroy() {
        eventBus.$off('setStanokFilter');
        eventBus.$off('setMaterialFilter');
    },

    created() {
        // подписываемся на событие
        eventBus.$on('setStanokFilter', (stanok) => {
            this.filter_stanok = stanok+'';
        });
        eventBus.$on('setMaterialFilter', (material) => {
            this.filter_material = material;
        });

        // при создании нам нужно получить список файлов в работе! мда... это пиздец
        this.$store.dispatch('retrieve_work_files')
        .then(()=> {})
        .catch((error) => {
            this.$admns.showNotify('Ошибка при получении рабочих файлов','error','сообщение системы')
            if (error.response.status == 401) {
                this.$router.push('logout')
            }
        });

        //загрузка станков
        if (this.$store.getters.getAllDirections.length == 0) {
            this.$store.dispatch("getDirections")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка станков",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }
            });
        }

        //загрузка типов материала
        if (this.$store.getters.getAllMaterials.length == 0) { // если список материалов пуст - то возможно он не загружен - пробуем загрузить
            this.$store.dispatch("getMaterials")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка материалов",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }

            });
        }

        // загрузка всех качествы печати
        if (this.$store.getters.getAllQuality.length==0) { //если список качеств печати пуст - то возможно он не загружен - загружаем
            this.$store.dispatch("getQuality")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка качества печати",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }

            });
        }

        if (this.$store.getters.allUsers.length==0) {//список пользователей пуст - попробуем загрузить снова
            this.$store.dispatch("retrieveUsers")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка пользователей",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }

            });
        }

        if (this.$store.getters.getAllPostTypes.length==0) {//список типов обработки пуст - попробуем загрузить снова
            this.$store.dispatch("getPostTypes")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка типов постобработки",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }
            });
        }
        if (this.$store.getters.allContragents.length==0) {//список типов обработки пуст - попробуем загрузить снова
            this.$store.dispatch("retrieveContragents")
            .then(()=>{})
            .catch((error)=>{
                this.$admns.showNotify("Ошибка загрузки списка типов постобработки",'error','Сообщение системы');
                console.log(error);
                if (error.response.status == 401) {
                   this.$router.push('logout')
                }
            });
        } 

    },

    computed : {

        isFilter() {
            return (this.filter_stanok != null)||(this.filter_material != null);
        },
      
       allOrders() {         
           if ((this.filter_stanok == null)&&(this.filter_material == null)) return this.$store.getters.getWorkFiles; // если нет фильтров - сразу отдаем список
           // значит тут есть фильтры - надо бы ковырять
           let orders = this.$store.getters.getWorkFiles;
           return orders.filter((order) => {
               let options = JSON.parse(order.options);
               let result = true;
               if (this.filter_stanok != undefined) result = result && (options.stanok == this.filter_stanok);
               if (this.filter_material != undefined) result = result && (options.material == this.filter_material);
               return result;
           });
       },

       getStanoks() {
          var list = [];
          if (this.$store.getters.getAllDirections==undefined) return list;

          this.$store.getters.getAllDirections.map((value,key)=>{
              //смотрим, подходит ли 
              let r = this.allowedDirections.indexOf(value.id)>-1;
              r = r && (value.own == 1);

              if (r) list.push({label:value.name, value:value.id+''}); // если все ок - добавляем его в список выбора
          });
          return list;

       },

       getMaterials() {

           var list = [];
           if (this.$store.getters.getAllMaterials == undefined) return list;
           this.$store.getters.getAllMaterials.map((value,key)=>{
               let m = JSON.parse(value.directions);// получили массив
               let isOk = false; // флаг что есть в списке.
               m.forEach(element => {
                   if (this.allowedDirections.indexOf(element)>-1) isOk = true;
               });
               if (isOk) list.push({label:value.name, value:value.id+''});
           });
           return list;
       },
    },


}
</script>

<style  lang="scss" scoped>
    .myBorder {
        border-radius: 2px;
        border : 1px solid rgb(202, 202, 202);
        background: rgb(228, 228, 228);
    }
    .filter-mark {
        border : 2px solid red;
        background: rgb(253, 234, 234);
    }
</style>
